<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :width="(!showUpdagradeScreen) ? '80%' : '40%'"
    transition="dialog-transition"
    max-width="1200px"
  >
    <v-card>
      <!-- Dialog Title -->
      <v-card-title>
        <div class="title" v-if="!showUpdagradeScreen">
          {{ $t("screener.quick.event.page.title") }}
          <div v-if="uploadingVideo && uploadingVideoStatus && uploadingVideoStatus == 'uploading'" class="caption grey--text text--darken-1 py-1 font-italic">
            {{ $t('screener.quick.event.creation.step.uploading.status.title') }} ({{ uploadingVideo.progress }}%)
          </div>
        </div>
        <div class="title bold-title" v-else>
          {{ $t('quick.event.upgrade.event.model.dialog.title') }}
        </div>
        <v-chip v-if="draftScreener && screener" class="px-2 mx-2" small :color="screener.status==DEFINES.QUCIK_EVENT_SCREENER_STATUS.PUBLISHED ?'success' :'warning'">
          {{ DEFINES.SCREENER_STATUS_STR[screener.status] }}
        </v-chip>
        <v-spacer></v-spacer>
        <!-- Close Button -->
        <v-btn
          small
          dark
          icon
          color="grey"
          class="mx-0"
          @click="validateEvent"
        >
          <v-icon small>$vuetify.icons.rms_close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Dialog Content -->
      <v-card-text>
        <template v-if="!showUpdagradeScreen">
          <v-stepper v-model="currentStep">
            <!-- Stepper Headers -->
            <v-stepper-header>
              <v-stepper-step :complete="currentStep > 1" step="1">
                {{ $t('screener.quick.event.creation.step.basic.details') }}
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="currentStep > 2" step="2">
                {{ $t('screener.quick.event.creation.step.configurations') }}
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="currentStep > 3" step="3">
                {{ $t('screener.quick.event.creation.step.overview') }}
              </v-stepper-step>
            </v-stepper-header>

            <!-- Stepper Items -->
            <v-stepper-items>
              <!-- Step 1: Basic Details -->
              <v-stepper-content step="1" class="pa-0 pa-3">
                <EventBasicDetails
                  ref="eventBasicDetails"
                  key="1"
                  :draftScreener="draftScreener"
                  @uploadingVideo="onVideoUploading"
                  @videoSourceChanged="onVideoSourceChange"
                />
              </v-stepper-content>

              <!-- Step 2: Configurations -->
              <v-stepper-content step="2">
                <EventConfiguration
                  ref="eventConfiguration"
                  key="2"
                  :uploadingVideo="uploadingVideo"
                  :videoFileName="videoFileName"
                  :uploadingVideoStatus="uploadingVideoStatus"
                  :videoSource="videoSource"
                  :currentStep="currentStep"
                  :screener="screener"
                  :draftScreener="draftScreener"
                  :videoSrcUrl="videoSrcUrl"
                  :film="film"
                  @getDraftScreener="handleDraftScreener"
                  @changeVideoSource="currentStep = 1"
                  @updateFilm="updateFilm"
                />
              </v-stepper-content>

              <!-- Step 3: Overview -->
              <v-stepper-content step="3">
                <EventOverView
                  ref="eventOverView"
                  :screener="screener"
                  key="3"
                  :overviewScreenMessage="overviewScreenMessage"
                />
              </v-stepper-content>

              <div class="mt-5">
                <v-divider></v-divider>
              </div>
            </v-stepper-items>
          </v-stepper>
        </template>
        <template v-else>
          <!-- Upgrade Event Screen -->
          <v-layout row wrap>
            <v-flex>
                <v-layout row wrap>
                    <v-flex xs12 md10 lg10>
                        <p>
                            {{ $t('screener.quick.event.upgrade.screen.message') }}
                        </p>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex>
                        <v-btn color="primary" @click="seatsDialog = true">
                            {{ $t('screener.upgrade_now.title') }}
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-2">
                    <v-flex>
                        <a href="javascript:void(0)" @click="onContinueFreeEvent" class="continue-link">
                            {{ $t('screener.quick.event.upgrade.screen.continue_text') }}
                        </a> <br/>
                        <small>({{ $t('screener.quick.event.upgrade.screen.continue_sub_text') }})</small>
                    </v-flex>
                </v-layout>
            </v-flex>
          </v-layout>
        </template>
        <!-- End Update Event Screen -->
      </v-card-text>

      <template>
        <v-divider></v-divider>
        <!-- Dialog Actions -->
        <v-card-actions>
          <v-btn small color="error" @click="validateEvent" v-if="[1,2].includes(currentStep)">
            {{ $t('common.field.discard') }}
          </v-btn>
          <!-- Back Button -->
          <v-btn
            @click.stop="onPrevStep()"
            small
            color="primary"
            v-if="currentStep > 1"
          >
            {{ $t('screener.btn.back') }}
          </v-btn>
          <v-btn  v-if="uploadingVideo && uploadingVideoStatus && uploadingVideoStatus == 'uploading'" small outline color="success">
            <v-icon class="px-1">mdi-upload</v-icon>
            <span class="pr-2">{{ $t('screener.quick.event.creation.step.uploading.status.title') }}</span>
            <v-progress-circular
              :rotate="360"
              :size="20"
              :width="5"
              :value="uploadingVideo.progress"
              color="teal"
              class="px-2"
            >
            </v-progress-circular>
          </v-btn>


          <v-spacer></v-spacer>

          <!-- Create, Continue, or Publish Button -->
          <v-btn
            v-if="currentStep == 1 && (!film || !screener ) && !showUpdagradeScreen"
            :loading="loading"
            @click.stop="onContinue()"
            small
            color="primary"
          >
            {{ $t('screener.quick.event.creation.step.form.create.event.btn') }}
          </v-btn>
          <v-btn
            v-else-if="film && screener && currentStep == 1"
            :loading="loading"
            @click.stop="onContinue()"
            small
            color="primary"
          >
            {{ $t('screener.quick.event.configuration.step.continue.btn') }}
          </v-btn>
          <v-btn
            v-else-if="currentStep == 2"
            :loading="loading"
            @click.stop="onPublishEvent()"
            small
            color="success"
            :disabled="uploadingVideoStatus && uploadingVideoStatus == 'uploading'"
          >
            {{ $t('screener.quick.event.configuration.step.publish.event.btn') }}
          </v-btn>
          <v-btn
            v-else-if="currentStep == 3"
            :loading="loading"
            :to="{name: 'screener.list'}"
            small
            color="primary"
          >
            {{ $t('screener.quick.event.creation.step.form.close.btn') }}
          </v-btn>

        </v-card-actions>
      </template>
    </v-card>
    <ConfirmModal :show="showPublishConfirmation"
      @onSubmit="onConfirmPublishEvent"
      @onCancel="onCancelPublishEvent"
      :heading="$t('screener.quick.event.confirmation.modal.heading')"
      :subHeading="$t('screener.quick.event.confirmation.modal.sub_heading')"
      :confirmButtonText="$t('screener.quick.event.configuration.step.publish.event.btn')"
      :cancelButtonText="$t('screener.btn.back')"
      />

      <ConfirmModal :show="showDiscardConfirmation"
        :heading="$t('screener.quick.event.screen.discard.heading')"
        :subHeading="$t('screener.quick.event.screen.discard.description')"
        :confirmButtonText="$t('common.field.yes')"
        :cancelButtonText="$t('common.field.no')"
        @onCancel="() => {
          showDiscardConfirmation = !showDiscardConfirmation
        }"
        @onSubmit="discardScreener"
      />

      <ConfirmModal :show="showAutoPublishConfirmation"
        :heading="$t('screener.quick.event.confirmation.auto_publish.popup.heading')"
        :subHeading="auto_publish_description"
        :confirmButtonText="$t('common.field.okay')"
        :cancelButtonText="$t('common.field.wait.processing')"
        @onSubmit="() => {
          showAutoPublishConfirmation = !showAutoPublishConfirmation
          this.onConfirmPublishEvent()
        }"
        @onCancel="() => {
          showAutoPublishConfirmation = !showAutoPublishConfirmation
        }"
      />
      <ConfirmModal :show="showAutoPublishConfirmation"
        :heading="$t('screener.quick.event.confirmation.auto_publish.popup.heading')"
        :subHeading="auto_publish_description"
        :confirmButtonText="$t('common.field.yes')"
        :cancelButtonText="$t('common.field.no')"
        @onSubmit="() => {
          showAutoPublishConfirmation = !showAutoPublishConfirmation
          this.onConfirmPublishEvent()
        }"
        @onCancel="() => {
          showAutoPublishConfirmation = !showAutoPublishConfirmation
        }"
      />
      <ConfirmModal :show="showUploaderAlert"
        isAlertOnly
        :heading="$t('screener.quick.event.uploading.alert.box.title')"
        :subHeading="$t('screener.quick.event.uploading.alert.box.message')"
        :confirmButtonText="$t('common.field.okay')"
        @onSubmit="showUploaderAlert = !showUploaderAlert"
      />
      <UpdateSeats
      v-if="
        screener &&
        seatsDialog &&
        screener.screening_type !== DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE
      "
      :seatsDialog.sync="seatsDialog"
      :screener="screener"
      :company="selected_company"
      @updateScreener="updateScreener"
      @redirectTo="redirectTo"
    ></UpdateSeats>
  </v-dialog>
</template>

<script>

/** Step Components */
import EventBasicDetails from './Steps/EventBasicDetails'
import EventConfiguration from './Steps/EventConfiguration'
import EventOverView from './Steps/EventOverView'
import ConfirmModal from '../../ConfirmModal.vue'
import { tzToUtc, utcToTz } from "@/helper";
import { mapGetters } from "vuex";
import DEFINES from '@/defines';
import UpdateSeats from "@/components/screener/UpdateSeats";

export default {
  name: 'QuickEventCreation',
  components: {
    EventBasicDetails,
    EventConfiguration,
    EventOverView,
    ConfirmModal,
    UpdateSeats
  },
  data() {
    return {
      dialog: true,
      currentStep: 1,
      uploadingVideo: null,
      selectedVideoSource: null,
      loading: false,
      film: null,
      screener: null,
      isEventPublished: false,
      thumbnail: null,
      showPublishConfirmation: false,
      showDiscardConfirmation:false,
      showUploaderAlert: false,
      showUpdagradeScreen: false,
      draftScreener: null,
      showAutoPublishConfirmation:false,
      auto_publish_description:null,
      seatsDialog: false,
      ScreenerPublishedStatus:DEFINES.QUCIK_EVENT_SCREENER_STATUS.DRAFT,
    };
  },
  watch: {
    uploadingVideo: {
      handler(newValue, oldValue){
        let vimeoID = newValue.vimeoId || null
        if(vimeoID){
          this.updateFilmAndScreener()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
      timezone: "getSelectedCompanyTimezone",
      selected_company: "getSelectedCompany",
    }),

    // Access EventBasicDetails component's form data
    eventBasicEl() {
      return this.$refs.eventBasicDetails;
    },
    eventBasicFormData() {
      return this.eventBasicEl.formData;
    },

    // Access EventConfiguration component's form data
    eventConfigurationEl() {
      return this.$refs.eventConfiguration;
    },
    eventConfigurationFormData() {
      return this.eventConfigurationEl.formData;
    },

    videoSource(){
      if(!this.draftScreener || this.selectedVideoSource){
        return this.selectedVideoSource
      }

      if(this.draftScreener && this.draftScreener.quick_event_configuration){
        return this.draftScreener.quick_event_configuration.videoSource || null
      }
    },

    // Construct the video source URL based on the selected source
    videoSrcUrl() {
      if(this.selectedVideoSource && this.videoSource === this.DEFINES.QUICK_EVENT.VIDEO_SOURCE.SAMPLE){
          return this.DEFINES.QUICK_EVENT.SAMPLE_VIDEO.VIMEO.hlsUrl;
      }

      if (this.selectedVideoSource && this.videoSource === this.DEFINES.QUICK_EVENT.VIDEO_SOURCE.UPLOAD) {
        return this.uploadingVideo.hlsUrl || null;
      }

      if(this.draftScreener && this.draftScreener.quick_event_configuration){
        return this.draftScreener.quick_event_configuration.videoSrcUrl || null
      }

      return null;
    },


    /**
     * Get vimeo id of attached video, weather its uploaded or sample
     * it should work fine
     */
    vimeoId(){
      if (this.selectedVideoSource && this.videoSource === this.DEFINES.QUICK_EVENT.VIDEO_SOURCE.SAMPLE) {
            return this.DEFINES.QUICK_EVENT.SAMPLE_VIDEO.VIMEO.vimeoId;
      }

      if (this.selectedVideoSource && this.videoSource === this.DEFINES.QUICK_EVENT.VIDEO_SOURCE.UPLOAD) {
        return this.uploadingVideo.vimeoId || null;
      }

      if(this.draftScreener && this.draftScreener.quick_event_configuration){
        return this.draftScreener.quick_event_configuration.vimeoId || null
      }
    },
    /**
     * Get vimeo id of attached video, weather its uploaded or sample
     * it should work fine
     */
    videoFileName(){
      if (this.selectedVideoSource && this.videoSource === this.DEFINES.QUICK_EVENT.VIDEO_SOURCE.SAMPLE) {
            return this.DEFINES.QUICK_EVENT.SAMPLE_VIDEO.VIMEO.fileName;
      }

      if (this.selectedVideoSource && this.videoSource === this.DEFINES.QUICK_EVENT.VIDEO_SOURCE.UPLOAD) {
        return this.uploadingVideo.fileName || null;
      }

      if(this.draftScreener && this.draftScreener.quick_event_configuration){
        return this.draftScreener.quick_event_configuration.fileName || null
      }
    },

    uploadingVideoStatus() {
      if (this.selectedVideoSource && this.videoSource === this.DEFINES.QUICK_EVENT.VIDEO_SOURCE.SAMPLE) {
        return null;
      }

      if (this.selectedVideoSource && this.videoSource === this.DEFINES.QUICK_EVENT.VIDEO_SOURCE.UPLOAD) {
        return this.uploadingVideo ? this.uploadingVideo.status :null;
      }

      if(this.draftScreener && this.draftScreener.quick_event_configuration){
        return this.draftScreener.quick_event_configuration.uploadingVideoStatus || null
      }
      return null
    },

    quickEventConfiguration() {
      return {
        vimeoId: this.vimeoId,
        videoSrcUrl: this.videoSrcUrl,
        videoSource: this.videoSource,
        uploadingVideoStatus: this.uploadingVideoStatus,
        fileName: this.videoFileName
      }
    },

    // Form data for creating/updating a film
    filmFormData() {
      return {
        title: this.eventBasicFormData.title,
        description: this.eventBasicFormData.description,
        is_external_src: true,
        external_url: this.videoSrcUrl,
        thumbs: this.film ? this.film.thumbs :[]
      };
    },

    // Form data for creating/updating a screener
    screenerFormData() {
      return {
        title: this.eventBasicFormData.title,
        description: this.eventBasicFormData.description,
        screening_starts_at: tzToUtc(this.eventBasicFormData.screening_starts_at, this.timezone) || null,
        screening_ends_at: tzToUtc(this.eventBasicFormData.screening_ends_at, this.timezone) || null,
        event_type: this.DEFINES.SCREENER_TYPE.VIRTUAL,
        limitation: this.eventBasicFormData.max_participants,
        film_ids: this.film ? [this.film.id] : [],
        is_vod_event: false,
        geo_blocking: this.eventConfigurationFormData.geo_blocking,
        event_configuration: this.eventConfigurationFormData.event_configuration,
        monetization_enabled: this.eventConfigurationFormData.monetization_enabled,
        monetization: this.eventConfigurationFormData.monetization,
        published: this.isEventPublished,
        registration_ends_at: this.screener ? this.screener.registration_ends_at : null,
        registration_starts_at: this.screener ? this.screener.registration_starts_at : null,
        screening_tolerance: this.screener ? this.screener.screening_tolerance : null,
        screening_type: this.DEFINES.SCREENING_TYPE.SINGLE_FILM_SCREENING,
        pricing_type: this.DEFINES.PREMIUM_SCREENING_PRICING_TYPE.NORMAL,
        auto_publish: (this.eventConfigurationFormData.auto_publish) ? 1 : 0,
        is_quick_event: true,
        quick_event_configuration: this.quickEventConfiguration,
        publish_screener_status:this.ScreenerPublishedStatus
      };
    },

    overviewScreenMessage() {
      // Early exit if no screener is set
      if (!this.screener) {
        return null;
      }

      // Handle messages only for published screeners
      if (this.screener.status === this.DEFINES.QUCIK_EVENT_SCREENER_STATUS.PUBLISHED) {
        // If a video source URL is available
        if (this.videoSrcUrl || this.uploadingVideoStatus != 'in_progress') {
          return {
            message: this.$t('quick.event.overview.step.live.event.message'),
            type: 'success'
          };
        } else {

          // Determine the message based on the auto_publish status
          if (this.screenerFormData.auto_publish) {
            return {
              message: this.$t('quick.event.overview.step.auto.publish.notification.message'),
              type: 'success'
            };
          } else {
            return {
              message: this.$t('quick.event.overview.step.manual.publish.notification.message'),
              type: 'warning'
            };
          }
        }
      }

      // No message for cases not covered above
      return null;
    }

  },
  created() {
    this.getDraftScreener()
  },
  methods: {
    async getDraftScreener(){
      await this.$store.dispatch("screener/getDraftScreener", {
        id: this.$route.params.screener_id,
      })
        .then((res) => {
        if (res) {
          this.draftScreener = res
          this.screener = res
          this.film = res.films[0]
        }
      })
      .catch((error) => {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      });
    },
    async discardScreener() {
      let screenerId = (this.draftScreener) ? this.draftScreener.id : null

      if (screenerId) {
        await this.$store.dispatch("screener/discardScreener", {
          screener_id:screenerId
        })
          .then((res) => {
            this.draftScreener = null;
            this.screener = null
            this.showDiscardConfirmation = false
            this.$router.push ({name: 'screener.list'});
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });

      } else {
        this.draftScreener = null;
        this.screener = null
        this.showDiscardConfirmation = false
        this.$router.push ({name: 'screener.list'});
      }

    },
    validateEvent() {
     /**
       * Check on Which Step user is
       * 1: Event Basics Details
       * 2. Event Configurations
       */
      if(this.uploadingVideo && this.uploadingVideoStatus && this.uploadingVideoStatus == 'uploading'){
        this.showUploaderAlert = true
        return;
      }
      if (this.currentStep == 1) {
        let {title, description, screening_starts_at, screening_ends_at } = this.screenerFormData
        /**
         * Check if User have added something in
         * Title, Description, Event Starts at and Event Ends at
         */
        if (title || description || screening_starts_at || screening_ends_at) {
         this.showDiscardConfirmation = true;
        } else {
          this.$router.push ({name: 'screener.list'});
          this.showDiscardConfirmation = false
        }
      }else if (this.currentStep == 2) {
        this.showDiscardConfirmation = true;
      } else {
        this.$router.push ({name: 'screener.list'});
      }

    },
    // Handle the "Continue" action to proceed to the next step
    onContinue() {
      if (!this.eventBasicEl.isFormValid()) {
        return;
      }

      if (this.draftScreener) {
        this.updateFilmAndScreener(() => this.currentStep++);
      } else {
        this.onCreate()
      }
    },

    // Handle the "Create" action for a new event
    async onCreate() {
      if (!this.eventBasicEl.isFormValid()) {
        return;
      }
      try {
        this.loading = true;

        // 1. Create the film
        const filmRes = await this.$store.dispatch("film/create", this.filmFormData);
        this.film = filmRes.film;

        // 2. Create the screener with the new film
        const screenerRes = await this.$store.dispatch("screener/create", this.screenerFormData);
        this.screener = screenerRes.result;
        this.draftScreener = screenerRes.result;

        this.uploadThumbnail();

        this.currentStep++;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    // Handle the "Update" action for an existing film and screener
    updateFilmAndScreener(onSuccess, onError) {

      if (!this.film && !this.screener) {
        return false
      }

      this.loading = true;

      // Upload thumbnail first
      this.uploadThumbnail();

      // Update the film
      this.$baseApi.post(`/member/company/${this.selected_company_id}/film/update`, {
          id: this.film.id,
          ...this.filmFormData,
        })
        .then(filmRes => {
          this.film = filmRes.film;
          // After updating the film, update the screener
          return this.$baseApi.post(`/member/company/${this.selected_company_id}/screener/${this.screener.id}/update`, {
            id: this.screener.id,
            ...this.screenerFormData,
          });
        })
        .then(screenerRes => {
          this.screener = screenerRes.result; // Update the screener object

          if (onSuccess) {
            onSuccess();
          }
        })
        .catch(error => {
          // Handle errors and show the message
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });

          // If error callback is provided, call it
          if (onError) {
            onError();
          }
        })
        .finally(() => {
          // Always set loading to false at the end
          this.loading = false;
        });
    },

    // Handle the "Publish Event" action
    onPublishEvent() {
      if (this.uploadingVideoStatus && this.uploadingVideoStatus == 'in_progress') {
          this.auto_publish_description = this.$t('screener.quick.event.confirmation.auto_publish.true.description')
          this.showAutoPublishConfirmation = true

      } else if (this.uploadingVideoStatus && this.uploadingVideoStatus == 'uploading' ) {
          this.auto_publish_description = this.$t('screener.quick.event.confirmation.video.in_uploading_phase');
          this.showAutoPublishConfirmation = true
      } else if(this.videoSrcUrl) {
        this.onConfirmPublishEvent()
      } else {
        this.showPublishConfirmation = true
      }
    },
    // Handle Confirm Publish
    onConfirmPublishEvent() {
      this.showPublishConfirmation = false
      if(!this.uploadingVideoStatus || this.uploadingVideoStatus != 'complete'){
        this.isEventPublished = false
      }else  {
        this.isEventPublished = true
      }

      /**
       * Check if Video is Not Selected : DEFINE.QUCIK_EVENT_SCREENER_STATUS.PUBLISHED
       */
      if (!this.vimeoId) {
        this.ScreenerPublishedStatus = DEFINES.QUCIK_EVENT_SCREENER_STATUS.PUBLISHED
        this.isEventPublished = true;
      }

      /**
       * Check if Video is Selected and is Uploading : DEFINE.QUCIK_EVENT_SCREENER_STATUS.PREPARED
       */
      if (this.videoInDraftMode) {
        this.ScreenerPublishedStatus = DEFINES.QUCIK_EVENT_SCREENER_STATUS.PREPARED
      } else if (this.uploadingVideoStatus) {
        /**
       * Check if Video is Uploaded and Processed : DEFINE.QUCIK_EVENT_SCREENER_STATUS.PREPARED
       */
        if (this.uploadingVideoStatus == 'complete') {
          this.ScreenerPublishedStatus = DEFINES.QUCIK_EVENT_SCREENER_STATUS.PUBLISHED
          this.isEventPublished = true;
        } else {
          this.ScreenerPublishedStatus = DEFINES.QUCIK_EVENT_SCREENER_STATUS.PREPARED
        }
      }
      
      this.updateFilmAndScreener(() => {
        this.showUpdagradeScreen = true
        this.currentStep++
      },
      () => {
        this.isEventPublished = false
      });
    },
    onContinueFreeEvent() {
      this.showUpdagradeScreen = false
    },
    // Handle Cancel Publish
    onCancelPublishEvent() {
      this.showPublishConfirmation = false
      this.currentStep--
    },
    // Handle navigation to the previous step
    onPrevStep() {
      if (this.currentStep == 3) {
        this.showUpdagradeScreen = false
      }
      this.currentStep--;
    },

    // Handle video uploading status change
    onVideoUploading(video) {
      this.uploadingVideo = video;
    },

    // Handle video source selection change
    onVideoSourceChange(value) {
      this.selectedVideoSource = value;
    },

    /* Upload thumbnail by vimeo thumbnail URL */
    async uploadThumbnail(){
        try {
          if(!this.uploadingVideo || !this.film || (this.film.thumbs && this.film.thumbs.length)){
            return;
          }
          var response = await this.$store.dispatch("files/add", {
              collection:'public',
              url: this.uploadingVideo.thumbnailUrl,
              path:null,
              name:this.screener?this.screener.title:this.uploadingVideo.fileName,
              model_type: "film",
              model_id: this.film.id
          });
          this.thumbnail = response.file;
          this.film.thumbs = [response.file.file_id];

          const filmRes = await this.$store.dispatch("film/update", {
            id: this.film.id,
            ...this.filmFormData,
          });
          this.film = filmRes.film;
        } catch (error) {
            this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error"
            });
        }
    },
    handleDraftScreener(value) {
      this.draftScreener = value
    },
    updateFilm(film) {
      this.film = film
    },
    updateScreener(sc) {
      this.screener.limitation = sc.limitation;
      this.screener.screening_type = sc.screening_type;
      this.screener.payment_charges = sc.payment_charges;
      this.showUpdagradeScreen = false;
      this.currentStep = 3;
    }
  },
};
</script>
<style scoped>
.bold-title {
  font-size: 25px !important;
  font-weight: bolder;
}
a.continue-link {
  text-decoration: underline;
  color: black !important;
}
.mt-2 {
  margin-top: 20px !important;
}
</style>
